import { publicAxios } from "@/api/public";
import {
  PayloadAuth,
  PayloadLogin,
  PayloadOnboarding,
  PayloadEmail,
  PayloadRefreshToken,
} from "../types";

import { AxiosResponse } from "axios";
import { api } from "@/api";
import {
  PayloadInvalidateToken,
  PayloadSuccessCaseExternal,
  PayloadSubmitSuccessCaseExternal,
} from "@/types";

class API {
  static getToken(payload: PayloadAuth): Promise<AxiosResponse> {
    return publicAxios.post("/authentication/authenticate", payload);
  }
  static getTokenUser(payload: PayloadOnboarding): Promise<AxiosResponse> {
    return publicAxios.get(`/user/onboarding/${payload.id}`, {
      params: payload.params,
    });
  }
  static getTokenCompany(payload: PayloadOnboarding): Promise<AxiosResponse> {
    return publicAxios.get(`/company/onboarding/${payload.id}`, {
      params: payload.params,
    });
  }
  static getLogin(payload: PayloadLogin): Promise<AxiosResponse> {
    return publicAxios.post("/login/company", payload);
  }
  static getLoginUser(payload: PayloadLogin): Promise<AxiosResponse> {
    return publicAxios.post("/login", payload);
  }
  static getLoginV2(payload: PayloadLogin): Promise<AxiosResponse> {
    return publicAxios.post("/login/v2", payload);
  }
  static postExternalIdAuth(payload: {
    externalId: string;
    tenantExternalId: string;
    language?: string;
  }): Promise<AxiosResponse> {
    return publicAxios.post("/login/external-id", payload);
  }
  static postRecoverPassword(payload: PayloadEmail): Promise<AxiosResponse> {
    return publicAxios.post("/login/redefinir-senha", payload);
  }
  static patchNewTokenUser(
    payload: PayloadRefreshToken
  ): Promise<AxiosResponse> {
    return api.patch("/login/refresh-token", payload);
  }
  static patchInvalidateToken(
    payload: PayloadInvalidateToken
  ): Promise<AxiosResponse> {
    return api.patch("/login/refresh-token/invalidate", payload);
  }
  static getSuccessCaseExternal(
    payload: PayloadSuccessCaseExternal
  ): Promise<AxiosResponse> {
    return publicAxios.get(`/success_case/registration/external`, {
      params: payload,
    });
  }
  static postSuccessCaseExternal(
    payload: PayloadSubmitSuccessCaseExternal
  ): Promise<AxiosResponse> {
    return publicAxios.post(
      `/success_case/registration/external?lang=${payload.lang}`,
      payload.params
    );
  }
  static getUserAuthenticationSystem(): Promise<AxiosResponse> {
    return api.get("/user/authentication/system");
  }
}

export default API;
